'use strict';
import Immutable from 'immutable';
import
{
	LOCATION_UPDATE,
	RESOURCE_REQUEST,
	RESOURCE_SUCCESS,
	RESOURCE_FAILURE,
	RESOURCE_DISPLAY,
	PROGRAM_LIST_FILTER,
	PROGRAM_LIST_CATEGORIZE,
	AUTO_COMPLETE_UPDATE_QUERY,
	AUTO_COMPLETE_UPDATE_SELECTION,
} from '../actions';


function reciveResource(state, resource) {
	return state.withMutations((map) => {
		map = (resource.data || []).reduce((reduction, value) => {
			return reduction
				.setIn(['cache', `/${value.type}/${value.id}`], Immutable.fromJS(value));
		}, map);
		
		map = (resource.included || []).reduce((reduction, value) => {
			return reduction
				.setIn(['cache', `/${value.type}/${value.id}`], Immutable.fromJS(value));
		}, map);

		return map;
	});
}

function filterProgramList(state, filters) {
	return state.setIn(['resources', 'pages', 'programs', 'meta', 'filters'], filters);  
}

function categorizeProgramList(state, categories) {
	return state.setIn(['resources', 'pages', 'programs', 'meta', 'categories'], categories);
}

function selectAutoComplete(state, index) {
	if(isNaN(index)) {
		return state.deleteIn(['auto_complete', 'meta', 'index']);
	} else {
		return state.setIn(['auto_complete', 'meta', 'index'], index);
	}
}

function queryAutoComplete(state, query) {
	return state.setIn(['auto_complete', 'meta', 'query'], query);
}


export function reducer(state = Immutable.Map(), action) {
	switch (action.type) {
		case LOCATION_UPDATE: return state
																		.setIn(['router','location'], action.location)
																		.setIn(['selectedResource'], '');

		case RESOURCE_REQUEST: return state
																		.setIn(['resources', action.endpoint, 'isFetching'], true)
																		.setIn(['resources', action.endpoint, 'items'], Immutable.List())
																		.deleteIn(['resources', action.endpoint, 'error']); 

		case RESOURCE_SUCCESS: return reciveResource(state, action.payload)
																		.setIn(['resources', action.endpoint, 'meta'], Immutable.Map(action.payload.meta)) 
																		.setIn(['resources', action.endpoint, 'isFetching'], false) 
																		.setIn(['resources', action.endpoint, 'lastUpdated'], Date.now())
																		.setIn(['resources', action.endpoint, 'include'], action.include)
																		.setIn(['resources', action.endpoint, 'items'], Immutable.List(action.payload.data.map((item) => {return { type:item.type, id:item.id };})))
																		.deleteIn(['resources', action.endpoint, 'error']); 
		
		case RESOURCE_FAILURE: return state
																		.setIn(['resources', action.endpoint, 'isFetching'], false) 
																		.setIn(['resources', action.endpoint, 'lastUpdated'], Date.now())
																		.setIn(['resources', action.endpoint, 'error'], Immutable.Map(action.error)); 

		case RESOURCE_DISPLAY: return state
																		.setIn(['selectedResource'], action.endpoint);

		case PROGRAM_LIST_FILTER: return filterProgramList(state, action.data);
		case PROGRAM_LIST_CATEGORIZE: return categorizeProgramList(state, action.data);
		case AUTO_COMPLETE_UPDATE_QUERY: return queryAutoComplete(state, action.query);
		case AUTO_COMPLETE_UPDATE_SELECTION: return selectAutoComplete(state, action.index);
		default:
			return state;
	}
}




/** WEBPACK FOOTER **
 ** ./app/reducers/index.js
 **/